import { useMemo } from "react"

import { CreateOrderDialogType } from "../createOrderTypes"

export type CreateOrderDialogTypeFlags = Readonly<{
    isRegularOrder: boolean
    isSpecialOrder: boolean
    isRefundOrder: boolean
    isSupplementaryOrder: boolean
}>

export function getCreateOrderDialogTypeFlags(dialogType: CreateOrderDialogType): CreateOrderDialogTypeFlags {
    const isRegularOrder = dialogType === CreateOrderDialogType.ORDER
    const isRefundOrder = dialogType === CreateOrderDialogType.CREDIT_NOTE
    const isSupplementaryOrder = dialogType === CreateOrderDialogType.SUPPLEMENTARY_ORDER
    const isSpecialOrder = !isRegularOrder

    return { isRegularOrder, isSpecialOrder, isRefundOrder, isSupplementaryOrder }
}

export function useCreateOrderDialogType(dialogType: CreateOrderDialogType): CreateOrderDialogTypeFlags {
    return useMemo(() => getCreateOrderDialogTypeFlags(dialogType), [dialogType])
}
